import { createNamespacedHelpers } from 'vuex'

const {
  mapActions: mapActionsCheckout,
  mapState: mapStateCheckout,
  mapGetters: mapGettersCheckout,
} = createNamespacedHelpers('checkout')

export default ({ app, store }, inject) => {
  const checkoutActions = {
    $store: store,
    ...mapActionsCheckout([
      'createEmptyCart',
      'getCustomerCart',
      'addCouponCode',
      'removeCouponCode',
      'removeItem',
      'removeItems',
      'removeAllItems',
      'refreshCart',
      'setCurrentStep',
      'updateCart',
      'updateCartItems',
      'updateMedicalPackageProducts',
      'setCartLoaded',
      'isRegisteredOnCheckout',
    ]),
  }

  // @todo używać getersow lub zmiana nazw, ustalic system aliasow
  const checkoutState = {
    $store: store,
    ...mapStateCheckout({
      items: state => state.items,
      prices: state => state.prices,
      attachments: state => state.attachments,
      mediclubPrice: state => state.mediclubPrice,
      noMediclubPrice: state => state.noMediclubPrice,
      cartId: state => state.id,
      appliedCoupons: state => state.appliedCoupons,
      currentStep: state => state.currentStep,
      cartLoaded: state => state.cartLoaded,
      now: state => state.now,
      reservationInterval: state => state.reservationInterval,
      reservationTimeout: state => state.reservationTimeout,
      removedItems: state => state.removedItems,
      isCartReadOnly: state => state.isCartReadOnly,
      setShippingMethodReadOnly: state => state.setShippingMethodReadOnly,
      billingAddress: state => state.billingAddress,
    }),
  }

  const checkoutGetters = {
    $store: store,
    ...mapGettersCheckout([
      'getTimeLeft',
      'getItemsQuantity',
      'getItems',
      'getAvailablePaymentMethods',
      'getPrices',
      'getMediclubPrices',
      'getNoMediclubPrices',
      'getAppliedCoupons',
      'getCurrentStep',
      'getFilteredItems',
      'getMaterialFeeItems',
      'getMaterialFeeProducts',
      'getPaymentMethods',
      'getLevelForCartItems',
      'getLevelForCartItemsRo',
      'isRegisteredOnCheckout',
    ]),
  }

  const isInCart = (uid) => {
    return checkoutState.items().some(({ product }) => product.uid === uid)
  }

  const addToCartMutation = async (productType) => {
    const types = (await import('../config/productsTypes')).default

    return types[productType]
  }

  const addToCartInput = (cartItems) => {
    return () => ({
      input: {
        cartId: app.$cart.cartId(),
        cartItems,
      },
    })
  }

  const addedToCart = async (payload) => {
    await checkoutActions.updateCart(Object.values(payload)[0].cart)
  }

  inject('cart', {
    ...checkoutState,
    ...checkoutActions,
    isInCart,
    ...checkoutGetters,
    addToCartMutation,
    addToCartInput,
    addedToCart,
  })
}
